import React from "react";
import {useNavigate} from 'react-router-dom';

function FondoPagina(props) {    
    const comandoNavigazione = useNavigate();    

    function vaiLink(link) {
        comandoNavigazione(link);
        window.scrollTo(0, 0);
    }
    
    return (
        <>
            <div style={{height:40, color:"#909090", backgroundColor:"#F5F5F5", marginLeft:20, marginRight:20}}>
            </div>

            <div style={{position:"relative", bottom: 30}}>
                {props.pagina!==undefined && props.pagina==="principale" ? <></> :
                <>
                    <span onClick={()=>vaiLink("/")} style={{color:"#4040FF", cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}}>Torna alla home →</span>
                    {props.dimensioniApp.flagflagPaginaOrizzontale ? "" : <><br/><br/></>}
                </>
                }
                <span style={{color:"#4040FF", cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}} onClick={() => vaiLink("/provaGratis")} >Prova gratis →</span>
                <span style={{color:"#4040FF", cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}} onClick={() => vaiLink("/acquista")}>Acquista →</span>
                <span style={{color:"#4040FF", cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}}  onClick={() => window.location.href = props.urlServizio}>Accedi →</span>
            </div>      

            <div style={{color:"#707070", backgroundColor:"#F5F5F5", marginLeft:20, marginRight:20, marginBottom:20, paddingTop:20, paddingBottom:20}}>
                <span style={{cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}} onClick={() => vaiLink("/chiSiamo")}>Chi siamo</span>
                <span style={{cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}} onClick={() => vaiLink("/privacy")}>Privacy & Cookies</span>
                <span style={{cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20}} onClick={() => vaiLink("/contatti")}>Contattaci</span>
                <div style={{fontSize:9, marginTop:20}}>(c) 2024, {props.produttore.ragioneSociale}, P.IVA {props.produttore.pIva}</div>
            </div>          
      </>
    )
}

export default FondoPagina;